import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  useTerminatePurchaseProcess,
  useCallbackPrompt,
} from '@selfserve/react-hooks';
import { ModalSettings } from '@selfserve/react-hocs';
import { routesPaths } from '@selfserve/react-utils';

export const useStopBreakingPurchaseProcess = (
  proccessTerminated: boolean,
  openErrorModal: (settings: ModalSettings) => void,
  exceptionUrls?: string[]
) => {
  const { t } = useTranslation();
  const { terminate } = useTerminatePurchaseProcess();
  const [blockPage, setBlockPage] = useState(false);
  const [callback, setCallback] = useState<(() => void) | null>(null);
  const [showPrompt, confirmNavigation, cancelNavigation] =
    useCallbackPrompt(blockPage, exceptionUrls);

  const allowNavigation = useCallback((callback?: () => void) => {
    setBlockPage(false);
    if (callback) setCallback(() => callback);
  }, []);

  useEffect(() => {
    if (callback) {
      callback();
      setCallback(null);
    }
  }, [callback]);

  useEffect(() => setBlockPage(!proccessTerminated), [proccessTerminated]);

  useEffect(() => {
    if (showPrompt) {
      openErrorModal({
        preventActionsOnClose: true,
        title: t('errors.break-purchase-title'),
        text: t('errors.break-purchase-message'),
        withDissmiss: true,
        dismissBtnText: t('common.cancel'),
        confirmBtnText: t('common.proceed-anyway'),
        dismissBtnId: 'kpfBreakPurchaseErrorCancel',
        confirmBtnId: 'kpfBreakPurchaseErrorProceed',
        onDismissBtnClick: cancelNavigation,
        onConfirmBtnClick: () => {
          confirmNavigation();
          terminate();
        },
        url: routesPaths.LOGIN,
      });
    }
  }, [showPrompt]);

  return { allowNavigation };
};
